(() => {
  const body = document.body;
  const dialog = document.querySelector('.nv-dialog');
  let opener;
  let toastTimer;
  const activePath = window.location.pathname.replace(/\/$/, '');
  document.querySelectorAll('.nv-category-pills a').forEach(link => {
    if (new URL(link.href).pathname.replace(/\/$/, '') === activePath) link.setAttribute('aria-current', 'page');
  });
  const closeDialog = () => dialog?.close();
  const stickyFor = form => [...document.querySelectorAll('nv-sticky-buy')].find(bar => bar.dataset.formId === form.id);
  const updatePrice = (container, option) => {
    const price = container?.querySelector('[data-price-wrapper]');
    if (!price || !option) return;
    const amount = Number(option.dataset.priceAmount);
    const compareAmount = Number(option.dataset.compareAmount);
    const onSale = Number.isFinite(compareAmount) && compareAmount > amount;
    const saving = onSale ? Math.round((compareAmount - amount) * 100 / compareAmount) : 0;
    price.classList.toggle('is-sale', onSale);
    price.querySelector('[data-current-price]').textContent = option.dataset.price;
    const compare = price.querySelector('[data-compare-price]');
    compare.textContent = onSale ? option.dataset.comparePrice : '';
    compare.hidden = !onSale;
    const badge = price.querySelector('[data-price-savings]');
    badge.textContent = saving > 0 ? `-${saving}%` : '';
    badge.hidden = saving <= 0;
  };
  const syncPurchase = form => {
    const button = form.querySelector('[data-product-submit]');
    const option = form.querySelector('[data-variant-select]')?.selectedOptions[0];
    const available = option ? option.dataset.available === 'true' : button.dataset.sold !== 'true';
    const busy = form.dataset.pending === 'true';
    const label = available ? button.dataset.addLabel : button.dataset.soldLabel;
    button.disabled = busy || !available;
    button.textContent = label;
    const sticky = stickyFor(form);
    if (sticky) {
      sticky.querySelector('[data-sticky-submit]').disabled = busy || !available;
      sticky.querySelector('[data-sticky-submit]').textContent = label;
      if (option) updatePrice(sticky.querySelector('[data-sticky-price]'), option);
    }
  };
  document.querySelectorAll('[data-product-submit]').forEach(button => button.dataset.sold = String(button.disabled));
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-close]')) closeDialog();
    const link = event.target.closest('[data-quick-view]');
    if (!link || !dialog || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = link;
    link.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(link.href);
      url.searchParams.set('section_id', 'nv-product');
      const response = await fetch(url);
      if (!response.ok) throw new Error('View unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const panel = parsed.querySelector('[data-nv-product-panel]');
      if (!panel) throw new Error('Missing product');
      panel.querySelectorAll('[data-product-submit]').forEach(button => button.dataset.sold = String(button.disabled));
      dialog.querySelector('[data-dialog-content]').replaceChildren(panel);
      dialog.showModal();
      document.documentElement.classList.add('nv-modal-open');
    } catch (_) { window.location.assign(link.href); }
    finally { link.removeAttribute('aria-busy'); }
  });
  if (dialog) {
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('nv-modal-open');
      if (opener?.isConnected && !document.querySelector('dialog[open]')) opener.focus();
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const b=dialog.getBoundingClientRect(); if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom) closeDialog(); } });
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
    if (!event.target.matches('[data-variant-select]')) return;
    const selected = event.target.selectedOptions[0];
    const panel = event.target.closest('[data-nv-product-panel]');
    updatePrice(panel.querySelector('[data-product-price]'), selected);
    const offerPrice = panel.querySelector('[data-offer-price]');
    if (offerPrice) offerPrice.textContent = selected.dataset.offerPrice;
    const offerRegular = panel.querySelector('[data-offer-regular]');
    if (offerRegular) offerRegular.textContent = selected.dataset.price;
    syncPurchase(event.target.form);
    if (!dialog?.contains(panel)) { const url=new URL(window.location.href);url.searchParams.set('variant',selected.value);history.replaceState({},'',url); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.nv-product-form')) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    const button = form.querySelector('[data-product-submit]');
    const status = form.querySelector('[data-form-status]');
    const drawer = document.querySelector('nv-cart-drawer');
    const trigger = event.submitter || button;
    form.dataset.pending = 'true';
    button.setAttribute('aria-busy','true');status.textContent='';syncPurchase(form);
    try {
      const data = new FormData(form);
      if (drawer) { data.append('sections',drawer.dataset.sectionId);data.append('sections_url',drawer.dataset.cartUrl); }
      const response = await fetch(body.dataset.addUrl,{method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description||status.dataset.error);
      status.textContent = status.dataset.success;
      if (drawer && typeof drawer.show === 'function') {
        await drawer.show(result.sections?.[drawer.dataset.sectionId],trigger);
      } else {
        try { const cartResponse=await fetch(body.dataset.cartJson);if(cartResponse.ok){const cart=await cartResponse.json();document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);} } catch (_) {}
        const toast=document.querySelector('.nv-toast');if(toast){toast.textContent=status.dataset.success;toast.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.hidden=true,3500);}
      }
    } catch(error) { status.textContent=error.message||status.dataset.error; }
    finally { delete form.dataset.pending;button.removeAttribute('aria-busy');syncPurchase(form); }
  });
})();


